import React from 'react';
import { Box, Stack, useTheme } from '@mui/material';
import { Handyman } from '@mui/icons-material';
import Search from '@/components/Search';
import ListTitle from '@/components/ListTitle';
import { ToolSummaryCard } from '@/components/tool/Summary';
import { useContext } from 'react';
import { ToolsContext } from '@my-helpers/common';
import { Notification } from '@/components/Notification';

const ToolsView: React.FC = () => {
    const context = useContext(ToolsContext);
    if (!context) {
        throw new Error('ToolsContext not found');
    }
    const { view, command } = context;
    const { tools, isLoading, error } = view;
    const { toggleUserToolStatus, clearError } = command;
    const theme = useTheme();

    return (
        <Stack padding={theme.spacing(3)}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                mb: 3
            }}>
                <ListTitle title="Tools" icon={Handyman} />
                <Search placeholder="Search tools..." />
                <Box sx={{ flexGrow: 1 }} />
            </Box>

            <Box sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(12, 1fr)',
                gap: 2
            }}>
                {
                    tools && tools.map((tool) =>
                        <Box
                            key={tool.provider}
                            sx={{
                                gridColumn: 'span 4',
                                display: 'flex',
                                flexDirection: 'row',
                                gap: 2
                            }}>
                            <ToolSummaryCard
                                tool={tool}
                                toggleUserToolStatus={toggleUserToolStatus}
                            />
                        </Box>
                    )
                }
            </Box>
            <Notification
                isLoading={isLoading}
                error={error}
                clearError={clearError}
                delay={300}
                autoHideDuration={1200}
            />
        </Stack>
    );
};

export default ToolsView;
